import { JSX } from 'react';

export function PageLoading(): JSX.Element {
  return (
    <div className="flex-grow-1 flex flex-col justify-around items-center">
      <span className="loading loading-xl loading-ring" />
      <div />
    </div>
  );
}
